import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductChangesPage } from "src/components/views/erp/productChanges/changes/ProductChangesPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/productManagement/productChanges")({
	staticData: { title: i18n.t("product_changes"), legacyViewKey: "productChangesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProductChangesPage />;
}
